import React, { ReactElement } from 'react';

import { Col, Divider, Layout, Row, TypographyText } from '@components/atoms';
import { EXPIRED_COMMENT, EXPIRED_TITLE } from '@constants/text';

function Expired(): ReactElement {
  return (
    <Layout>
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="title">{EXPIRED_TITLE}</TypographyText>
        </Col>
      </Row>
      <Divider margin={3} yzTypeDivider="TRANSPARENT_LITTLE_SPACE" />
      <Row>
        <Col yzTypeCol="center">
          <TypographyText yzTypeTypographyText="basic">{EXPIRED_COMMENT}</TypographyText>
        </Col>
      </Row>
    </Layout>
  );
}

export default Expired;
